import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Stack/Stack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Wilds/VillasLaunchBanner/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(marketing)/wilds/villas/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/VillasLaunchGallery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/VillasLaunchHarmony/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/VillasLaunchRegistration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/VillasLaunchWelcome/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/WildsCommonHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/WildsLaunchFloatingButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/WildsLaunchLogo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Wilds/WildsLaunchSpecification/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AnimatedDownArrow/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonTransition/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Desktop"] */ "/app/src/components/Desktop/Desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DynamicButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/app/src/components/Mobile/Mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ParallaxBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ParallaxText/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisclaimerToggleProvider"] */ "/app/src/hooks/useDisclaimerToggle.tsx");
